export const isPdfUrl = (val) => {
  return (val?.key || val?.url || "").toLowerCase().includes(".pdf");
};
